import React from "react";
import { QualifiedFeature } from "fe-common/graphql";
import { featureToLines } from "fe-common/logic";
import { styled } from "@mui/material";
import clsx from "clsx";
import { Relations } from "shared";
import { usePatientFeatureFlags } from "../../hooks/usePatientFeatureFlags";

//region [[ Styles ]]

const SymptomTextView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]
export interface SymptomTextProps {
  className?: string;
  symptom: QualifiedFeature;
  mutualInformation?: number;
}
//endregion [[ Props ]]

//region [[ Functions ]]
export function capitalizeFirstLetter(text: string[]) {
  return text.map((t, index) =>
    index === 0 ? t.charAt(0).toUpperCase() + t.slice(1) : t,
  );
}
export const symptomTxt = (
  symptom: QualifiedFeature,
  isForm = false,
): string[] => {
  const text = featureToLines(
    symptom,
    false,
    [Relations.EXPOSURE_TO],
    [],
    true,
    isForm,
  );
  return text.map((t) => t.replace("No ", "")); //Don't use hard coded No
};

export const symptomQualifierTxt = (symptom: QualifiedFeature): string[] => {
  const text = featureToLines(symptom, true, [Relations.EXPOSURE_TO], [], true);
  return text.map((t) => t.replace("No ", "")); //Don't use hard coded No
};
//endregion [[ Functions ]]

export const SymptomText = ({
  symptom,
  mutualInformation,
  ...props
}: SymptomTextProps) => {
  const debugMode = usePatientFeatureFlags("debugSheet");
  return (
    <SymptomTextView className={clsx(props.className, "symptom-text")}>
      {capitalizeFirstLetter(symptomTxt(symptom))}
      {debugMode && mutualInformation
        ? ` (${mutualInformation.toPrecision(3)})`
        : ``}
    </SymptomTextView>
  );
};
